import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { uniqBy } from 'lodash'
import * as R from 'ramda'

import Panel from '../../../UniformComponents/Panel'
import Button from '../../../UniformComponents/Button'
import Tooltip from '../../../UniformComponents/Tooltip'
import LanguageWarning from '../../Survey/Modals/LanguageWarning'

import './survey-wizard-layout.scss'

@observer
class SurveyWizardLayout extends Component {
    renderBtn = (finalStages) => {
        const { curStage, wizardStore } = this.props
        return (
            <div className="btn-wrapper">
                {curStage !== 0 && !(curStage === finalStages.length - 1 && ['EM', 'R'].includes(wizardStore.surveyType)) && finalStages[curStage].back && (
                    <Button
                        label={i18n.t('back')}
                        cssClass="regular tertiary"
                        onClick={finalStages[curStage].back}
                    />
                )}
                {finalStages[curStage].continue !== undefined && (
                    <Button
                        label={curStage === finalStages.length - 1
                            ? i18n.t('finish') : i18n.t('continue')}
                        cssClass="regular primary"
                        onClick={() => { finalStages[curStage].continue() }}
                        disabled={wizardStore.disableContinueBtn
                            || (curStage === finalStages.length - 1 && wizardStore.disableFinishBtn)}
                    />
                )}
            </div>
        )
    }

    render() {
        const { stages, curStage, wizardStore } = this.props
        const finalStages = stages.filter((stage) => (!stage.isHide))
        const stageList = uniqBy(finalStages, 'stageNo')

        if (!(R.isEmpty(finalStages) || R.isNil(finalStages))) {
            return (
                <div id="survey-wizard" className={wizardStore.isRapidSurvey ? 'rapidSurvey' : ''}>
                    <LanguageWarning
                        show={wizardStore.showLocaleWarning}
                        onHide={() => { wizardStore.showLocaleWarning = false }}
                    />
                    <Panel cssClass="survey-panel overflow-visible">
                        <div className="stage-head">
                            {
                                stageList.map(({ stageNo, stageName }, index) => (
                                    <div className={`stage ${finalStages[curStage].stageNo === stageNo ? 'selected' : ''}`}>
                                        {(finalStages[curStage].stageNo > stageNo)
                                            ? <i className="fa-light fa-check" />
                                            : <span className="stage-no">{index + 1}</span>}
                                        <p>{stageName}</p>
                                        {(finalStages[curStage].stageNo < stageNo) && (
                                            <Tooltip
                                                text={i18n.t(`surveyWizard.fill.step.${index}`)}
                                                direction="up"
                                            />
                                        )}
                                    </div>
                                ))
                            }
                        </div>
                        <div className="stage-comp" style={{ paddingBlock: (curStage === finalStages.length - 1) ? '30px 0' : '30px' }}>
                            <div className="title-wrapper">
                                <h1 className="title">{finalStages[curStage].pageTitle}</h1>
                                {finalStages[curStage].pageDesc && <h4 className="desc">{finalStages[curStage].pageDesc}</h4>}
                            </div>
                            {finalStages[curStage].component()}
                            {this.renderBtn(finalStages)}
                        </div>
                    </Panel>
                </div>
            )
        }
        return null
    }
}

export default SurveyWizardLayout
